import { navigateTo } from "./http";

export const SECURE_ZONE_ERROR_CODE = "ERR_SECURE_ZONE";
export const AUTH_REQUIRED_ERROR_CODE = "ERR_AUTH_REQUIRED";
const SECURE_ZONE_REDIRECT_PATH = "/dashboard/verify-fingerprint";
const AUTH_REQUIRED_REDIRECT_PATH = "/dashboard/sign-in";

let secureZoneRedirectTriggered = false;
let authRedirectTriggered = false;

const isSecureZoneRedirectTriggered = () => secureZoneRedirectTriggered;
const isAuthRedirectTriggered = () => authRedirectTriggered;

const markSecureZoneRedirectTriggered = () => {
  secureZoneRedirectTriggered = true;
};

const markAuthRedirectTriggered = () => {
  authRedirectTriggered = true;
};

const buildAuthRedirectUrl = () => {
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return `${AUTH_REQUIRED_REDIRECT_PATH}?RedirectUrl=${encodeURIComponent(currentUrl)}`;
};

const normalizeErrorCode = (value: unknown): string | undefined => {
  if (typeof value !== "string") {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const isSecureZoneError = (value: unknown): boolean => {
  const normalized = normalizeErrorCode(value);
  return normalized === SECURE_ZONE_ERROR_CODE;
};

export const isAuthRequiredError = (value: unknown): boolean => {
  const normalized = normalizeErrorCode(value);
  return normalized === AUTH_REQUIRED_ERROR_CODE;
};

export const triggerSecureZoneRedirect = () => {
  if (isSecureZoneRedirectTriggered()) {
    return;
  }
  markSecureZoneRedirectTriggered();
  void navigateTo(SECURE_ZONE_REDIRECT_PATH);
};

export const triggerAuthRequiredRedirect = () => {
  if (isAuthRedirectTriggered()) {
    return;
  }
  markAuthRedirectTriggered();
  void navigateTo(buildAuthRedirectUrl());
};

export const ensureSecureZoneRedirectFromError = (value: unknown): string | null => {
  if (isSecureZoneError(value)) {
    triggerSecureZoneRedirect();
    return SECURE_ZONE_ERROR_CODE;
  }
  if (isAuthRequiredError(value)) {
    triggerAuthRequiredRedirect();
    return AUTH_REQUIRED_ERROR_CODE;
  }
  if (value instanceof Error) {
    if (isSecureZoneError(value.message)) {
      triggerSecureZoneRedirect();
      return SECURE_ZONE_ERROR_CODE;
    }
    if (isAuthRequiredError(value.message)) {
      triggerAuthRequiredRedirect();
      return AUTH_REQUIRED_ERROR_CODE;
    }
  }
  return null;
};

export const ensureSecureZoneRedirectFromResponse = async (response: Response): Promise<string | null> => {
  if (response.status !== 403 && response.status !== 401) {
    return null;
  }
  try {
    const body = await response.clone().text();
    if (isSecureZoneError(body)) {
      triggerSecureZoneRedirect();
      return SECURE_ZONE_ERROR_CODE;
    }
    if (isAuthRequiredError(body)) {
      triggerAuthRequiredRedirect();
      return AUTH_REQUIRED_ERROR_CODE;
    }
  } catch {
    return null;
  }
  return null;
};
